import SEOMetadata from '@/components/SEOMetadata';
import React, { Suspense, useRef, useEffect, useState } from 'react';
import StyledAbout from './styles/ProductsPageStyles';
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadHeader = () => import('@/components/landing/about/Header');
const Header = React.lazy(loadHeader);
const loadDemoc = () => import('@/components/landing/about/Democ');
const Democ = React.lazy(loadDemoc);
const loadValues = () => import('@/components/landing/about/OurValues');
const Values = React.lazy(loadValues);
const loadWhy = () => import('@/components/landing/about/WhyWeExist');
const Why = React.lazy(loadWhy);
const loadJourney = () => import('@/components/landing/about/OurJourney');
const Journey = React.lazy(loadJourney);
const loadHow = () => import('@/components/landing/about/HowWeWork');
const How = React.lazy(loadHow);


const loadSolution = () => import('@/components/landing/about/OurSolution');
const Solution = React.lazy(loadSolution);
const loadJoin = () => import('@/components/landing/about/JoinMission');
const Join = React.lazy(loadJoin);

const loadGetStarted = () => import('@/components/landing/GetStarted');
const GetStarted = React.lazy(loadGetStarted);
const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);


const AboutPage: React.FC = () => {
  useIdlePrefetch([loadHeader, loadDemoc, loadValues, loadWhy, loadJourney, loadHow, loadSolution, loadJoin, loadGetStarted, loadFooter]);
  const graphicRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => { window.track('about_page_visited') }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '900px',
        threshold: 0.01
      }
    );

    if (graphicRef.current) {
      observer.observe(graphicRef.current);
    }

    return () => {
      if (graphicRef.current) {
        observer.unobserve(graphicRef.current);
      }
    };
  }, []);

  return (
    <>
      <SEOMetadata
        title="Financial Data API Company — Market Data & Alternative Data Platform"
        description="Learn about AxionQuant, the financial data API company providing real-time market data, alternative data, and company fundamentals to quants, developers, and financial institutions."
        canonicalUrl="https://axionquant.com/about"
      />

      <StyledAbout>


        <div ref={graphicRef}>
          <Header isVisible={isVisible}/>
        </div>

        <Democ/>

        <Suspense fallback={null}>
          <Values/>
          <Why/>
          <Journey/>
          <How/>
          <Solution/>
          <Join/>

          <GetStarted
            title="Ready to Transform Your Trading?"
            text="Join thousands of traders and institutions using Axion's financial data API to make smarter, faster research decisions with decades of daily and hourly market intelligence."
            primary={{ title: "Start for free", url: "/login" }}
            secondary={{ title: "Contact us", url: "/pricing" }}
          />

          <Footer />
        </Suspense>
      </StyledAbout>
    </>
  );
};

export default AboutPage;
